import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  getMission: (param) => {
    return httpApi.getDataViaApi({
      url: api.mission.getMission,
      queryParams: param
    })
  },
  getMissionDetail: (id) => {
    return httpApi.getDataViaApi({
      url: api.mission.getMissionDetail(id)
    })
  }
}
